import { Table, TableColumnsType } from "antd";
import _ from "lodash";
import moment from "moment";
import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { getHomeworkStudents } from "../../../api/statistics.api";
import useAxios from "../../../hooks/useAxios";
import config from "../../../lib/config";
import exportTable from "../../../lib/exportTable";
import { IGetHomeworkStudents, IHomeworkStudent } from "../../../models/statistics.model";
import { RootState } from "../../../store/rootReducer";
import DownloadButton from "../../DownloadButton";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import Pagination from "../../Pagination";

interface IProps {
  res: any;
  pageNo: number;
  setPageNo: (pageNo: number) => void;
  srtDate: string|undefined;
  endDate: string|undefined;
  campusCodes: string[];
  courseCode: string|undefined;
  semesterCode: number|undefined;
}

const List: FC<IProps> = ({
  res,
  pageNo,
  setPageNo,
  srtDate,
  endDate,
  campusCodes,
  courseCode,
  semesterCode
}) => {
  const { t } = useTranslation();
  const { auth } = useSelector((state: RootState) => state.auth);
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetHomeworkStudents>();

  useEffect(() => {
    if (res2 && !isLoading2) {
      const _data: any = _.cloneDeep(res2?.data);
      _data.forEach((item: any) => {
        item.timetableDate = moment(item.timetableDate).format('YYYY.MM.DD');
      });
      const currentDate = moment(new Date());
      exportTable(columns, _data, `${t('statistics.homework.title1')}(${t('statistics.homework.tab1')})_(${currentDate.format('YYYYMMDD')})`, `${t('statistics.homework.tab1')}`, [12, 10, 20, 20, 15, 12, 25, 12, 20, 15, 10]);
    }
  }, [res2, isLoading2]);

  const onExportTable = () => {
    if (!semesterCode) return;

    execute2(getHomeworkStudents({
      semesterCode,
      srtDate,
      endDate,
      campusCode: auth.hqYn === 'Y'
        ? campusCodes
        : (campusCodes.length ? campusCodes : auth.campus),
      courseCode,
      perPage: 999999999,
      pageNo: 1,
    }));
  }

  const columns: TableColumnsType<IHomeworkStudent> = [
    {
      title: t('common.menu.campus'),
      dataIndex: 'campusKorName',
      key: 'campusKorName',
      align: 'center',
    },
    {
      title: t('student.student.column5'),
      dataIndex: 'memberKorName',
      key: 'memberKorName',
      align: 'center',
    },
    {
      title: t('auth.login.label1'),
      dataIndex: 'webId',
      key: 'webId',
      align: 'center',
    },
    {
      title: t('student.student.column64'),
      dataIndex: 'memberCode',
      key: 'memberCode',
      align: 'center',
    },
    {
      title: t('statistics.homework.column4'),
      dataIndex: 'depth1Name',
      key: 'depth1Name',
      align: 'center',
    },
    {
      title: t('statistics.homework.column5'),
      dataIndex: 'subjectName',
      key: 'subjectName',
      align: 'center',
    },
    {
      title: 'Activity',
      dataIndex: 'depth2Name',
      key: 'depth2Name',
      align: 'center',
    },
    {
      title: t('statistics.dttt.column1'),
      dataIndex: 'courseName',
      key: 'courseName',
      align: 'center',
    },
    {
      title: t('common.menu.class'),
      dataIndex: 'className',
      key: 'className',
      align: 'center',
    },
    {
      title: t('statistics.dttt.column3'),
      dataIndex: 'timetableDate',
      key: 'timetableDate',
      align: 'center',
      render: value => moment(value).format('YYYY.MM.DD'),
    },
    {
      title: t('common.column.score'),
      dataIndex: 'score',
      key: 'score',
      align: 'center',
    },
  ];

  return (
    <>
      {isLoading2 && <Loader />}
      <ErrorResponse error={error2} />

      <div className="comm-bx__between">
        <div className="comm-sch_result">
          Total: {<b>{res?.total}</b>}
        </div>
      </div>
      <div className="comm-table__area">
        <Table
          columns={columns}
          dataSource={res?.data}
          pagination={{
            current: pageNo,
            pageSize: config.pageSize,
          }}
        />
      </div>
      <div className="comm-bx__between">
        <DownloadButton onClick={onExportTable} />
        <div className="common-paging center">
          <Pagination
            count={res?.total || 0}
            page={pageNo}
            setPage={setPageNo}
          />
        </div>
      </div>
    </>
  );
}

export default List;
